import { rem } from 'polished';
import styled, { css } from 'styled-components';

import { bokehTheme } from '@vimeo/bokeh-theme';
import { DownloadArrow } from '@vimeo/iris/icons';
import { VimeostockDark, VimeostockLight } from '@vimeo/iris/illustration';
import { Header } from '@vimeo/iris/typography';

export const ClipCardWrapper = styled.section`
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.16);
  margin-bottom: 1.25rem;
  transition: all 0.25s linear;
  background-color: #000000;
  display: flex;
  flex-direction: column;
  flex: 0 1 330px;
  margin-right: 0.75rem;
  position: relative;
`;

export const DescriptionBox = styled('div')<{ darkTheme: boolean }>`
  padding: 1.25rem;
  position: relative;
  background-color: ${(props) => (props.darkTheme ? '#2E2E2E' : '#fff')};
  min-height: 151px;
  > p {
    display: block;
    display: -webkit-box;
    margin: 0.75rem 1.25rem 0 0;
    font-weight: 400;
    max-height: 41px;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const ClipTitle = styled(Header).attrs({ size: '3' })`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin-right: 3rem;
  ${(props) => (props.theme.name === 'dark' ? `color: '#fff';` : '')};
`;

export const PlayerPlaceholder = styled.div`
  width: 100%;
  height: 250px;
`;

const nonFeaturedStockWrapperStyles = css`
  height: ${rem(40)};
  margin-top: ${rem(12)};
  display: flex;
  justify-content: space-between;
  position: relative;
`;

const featuredStockWrapperStyles = css`
  margin-top: 0;
  position: static;
  .StyledButtons {
    right: ${rem(5)};
  }
  @media only screen and (max-width: 1024px) {
    display: initial;
  }
`;

export const StockWrapper = styled.div<{ isFeatured?: boolean }>`
  ${(props) => (props.isFeatured ? featuredStockWrapperStyles : nonFeaturedStockWrapperStyles)};
`;

const stockIconStyles = css`
  width: ${rem(140)};
  height: ${rem(32)};
  cursor: pointer;
`;

export const StockIconLight = styled(VimeostockLight)`
  ${stockIconStyles};
`;

export const StockIconDark = styled(VimeostockDark)`
  ${stockIconStyles};
`;

type StyledButtonsProps = {
  isPaid?: boolean;
  isFree?: boolean;
  isSmartPhoneOrTablet: boolean;
};

export const StyledButtons = styled.span<StyledButtonsProps>`
  width: ${rem(80)};
  height: ${rem(37)};
  display: flex;
  z-index: 2;
  position: absolute;
  bottom: ${rem(3)};
  right: 0;
  ${(props) =>
    props.isSmartPhoneOrTablet || (!props.isPaid && props.isFree) ? `width: ${rem(40)}` : ''};
`;

export const AddButton = styled.div`
  margin-left: ${rem(4)};
`;

export const ButtonBackground = styled.div<{ $theme: string }>`
  ${(props) =>
    props.$theme === 'dark' ? `background-color: ${bokehTheme.colors.gray['600']};` : ''};
`;

export const StyledDownloadIcon = styled(DownloadArrow)`
  path {
    fill: white;
  }
`;
